import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toastMessage } from 'utils';
import useVideoContext from './useVideoContext';

export default () => {
  const { t } = useTranslation('labels');
  const { room } = useVideoContext();
  const participant = room?.localParticipant;
  const [networkQualityLevel, setNetworkQualityLevel] = useState(participant?.networkQualityLevel);

  useEffect(() => {
    const handleNetworkQualityLevelChange = (newNetworkQualityLevel) => setNetworkQualityLevel(newNetworkQualityLevel);
    if (participant) {
      setNetworkQualityLevel(participant.networkQualityLevel);
      participant.on('networkQualityLevelChanged', handleNetworkQualityLevelChange);
      return () => {
        participant.off('networkQualityLevelChanged', handleNetworkQualityLevelChange);
      };
    }
  }, [participant]);

  useEffect(() => {
    if (participant) {
      setNetworkQualityLevel(participant.networkQualityLevel);
    }
  }, [participant?.networkQualityLevel]);

  useEffect(() => {
    if (networkQualityLevel && networkQualityLevel < 2) {
      toastMessage(`${t('poor_network_connection')}.`, t('please_check_your_internet_connection_or_try_rejoining'), true);
    }
  }, [networkQualityLevel]);

  return networkQualityLevel;
};
